// extracted by mini-css-extract-plugin
export default {"background":"Video_background__Ogo3v"};